import { createRouter, createWebHistory } from 'vue-router';

import HomeView from '../views/HomeView.vue'
import HomeView2 from '../views/HomeView2.vue'
import TableView from "../views/TableView.vue";
import LoginView from "../views/LoginView.vue";
import EsquemasView from "@/views/EsquemasView";
import UsuariosView from "@/views/UsuariosView";
import SubirDocumentoView from "@/views/SubirDocumentoView";
import ListasView from "@/views/ListasView.vue";
import DocumentoView from "@/views/DocumentoView.vue";
import AgendaContactos from "@/views/AgendaContactos.vue";
import BuscadorView from "@/views/BuscadorView.vue";
import TareasView from "@/views/TareasView.vue";
import PanelControlTareasView from "@/views/PanelControlTareasView.vue";
import AprobacionAvanzadaView from "@/views/AprobacionAvanzadaView.vue";
import PanelConsultaAprobacionView from "@/views/PanelConsultaAprobacionView.vue";
import InformesView from "@/views/InformesView.vue";
import CuadroMandoView from "@/views/CuadroMandoView.vue";

const routes = [
    { 
        path: '/', 
        component: HomeView,
        meta: { requiresAuth: true }
    },
    { 
        path: '/dashboard', 
        component: HomeView2,
        meta: { requiresAuth: true }
    },
    { 
        path: '/login', 
        component: LoginView,
        meta: { requiresAuth: false }
    },
    { 
        path: '/esquemas', 
        component: EsquemasView,
        meta: { requiresAuth: true }
    },
    { 
        path: '/usuarios', 
        component: UsuariosView,
        meta: { requiresAuth: true }
    },
    { 
        path: '/listas', 
        component: ListasView,
        meta: { requiresAuth: true }
    },
    { 
        path: '/esquema/:id', 
        component: TableView,
        meta: { requiresAuth: true }
    },
    { 
        path: '/esquema/:id/informes', 
        component: InformesView,
        meta: { requiresAuth: true }
    },
    { 
        path: '/esquema/:esquemaId/registro/:registroId', 
        component: DocumentoView,
        meta: { requiresAuth: true }
    },
    { 
        path: '/subir-documento', 
        component: SubirDocumentoView,
        meta: { requiresAuth: true }
    },
    { 
        path: '/agenda', 
        component: AgendaContactos,
        meta: { requiresAuth: true }
    },
    { 
        path: '/buscador', 
        component: BuscadorView,
        meta: { requiresAuth: true }
    },
    { 
        path: '/tareas', 
        component: TareasView,
        meta: { requiresAuth: true }
    },
    { 
        path: '/panel-control-tareas', 
        component: PanelControlTareasView,
        meta: { requiresAuth: true }
    },
    { 
        path: '/aprobacion-avanzada', 
        component: AprobacionAvanzadaView,
        meta: { requiresAuth: true }
    },
    { 
        path: '/panel-consulta-aprobacion', 
        component: PanelConsultaAprobacionView,
        meta: { requiresAuth: true }
    },
    { 
        path: '/cuadro-mando', 
        component: CuadroMandoView,
        meta: { requiresAuth: true }
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes
});

// Guard de navegación para verificar autenticación
router.beforeEach(async (to, from, next) => {
    // Importar dinámicamente para evitar dependencias circulares
    const { useAuth } = await import('@/composables/useAuth')
    const { checkAuth } = useAuth()

    // Verificar si la ruta requiere autenticación
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
    
    // Si la ruta requiere autenticación
    if (requiresAuth) {
        // Verificar el estado de autenticación
        const isAuth = await checkAuth()
        
        if (!isAuth) {
            // Si no está autenticado, redirigir al login con la ruta de destino
            next({
                path: '/login',
                query: { redirect: to.fullPath }
            })
            return
        }
    } else if (to.path === '/login') {
        // Si está intentando acceder al login, verificar si ya está autenticado
        const isAuth = await checkAuth()
        
        if (isAuth) {
            // Si ya está autenticado, redirigir a la página principal
            next('/')
            return
        }
    }
    
    // Continuar con la navegación
    next()
})

export default router;